'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactFontawesome = require('@fortawesome/react-fontawesome');

var _FormattedMessage = require('../../components/Formatted/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _link = require('@liveauctioneers/caterwaul-components/lib/link');

var _link2 = _interopRequireDefault(_link);

var _BannerOutdatedBrowser = require('./BannerOutdatedBrowser.scss');

var _BannerOutdatedBrowser2 = _interopRequireDefault(_BannerOutdatedBrowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BannerOutdatedBrowser = function (_PureComponent) {
    (0, _inherits3.default)(BannerOutdatedBrowser, _PureComponent);

    function BannerOutdatedBrowser() {
        (0, _classCallCheck3.default)(this, BannerOutdatedBrowser);
        return (0, _possibleConstructorReturn3.default)(this, (BannerOutdatedBrowser.__proto__ || (0, _getPrototypeOf2.default)(BannerOutdatedBrowser)).apply(this, arguments));
    }

    (0, _createClass3.default)(BannerOutdatedBrowser, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                name = _props.name,
                majorVersion = _props.majorVersion;


            var formalName = (0, _jsx3.default)(_FormattedMessage2.default, {
                id: name
            });
            var chrome = (0, _jsx3.default)(_link2.default, {
                to: 'https://www.google.com/chrome/browser/desktop/',
                target: '_blank',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'chrome'
            }));
            var firefox = (0, _jsx3.default)(_link2.default, {
                to: 'https://www.mozilla.org/en-US/firefox/new/',
                target: '_blank',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'firefox'
            }));
            var edge = (0, _jsx3.default)(_link2.default, {
                to: 'https://www.microsoft.com/en-us/windows/microsoft-edge',
                target: '_blank',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'edge'
            }));
            var safari = (0, _jsx3.default)(_link2.default, {
                to: 'https://support.apple.com/downloads/safari',
                target: '_blank',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'safari'
            }));

            return (0, _jsx3.default)('div', {
                className: _BannerOutdatedBrowser2.default['la-notification-bar']
            }, void 0, (0, _jsx3.default)('div', {
                className: _BannerOutdatedBrowser2.default['notification-message']
            }, void 0, (0, _jsx3.default)('div', {
                className: _BannerOutdatedBrowser2.default['message-status']
            }, void 0, (0, _jsx3.default)(_reactFontawesome.FontAwesomeIcon, {
                className: _BannerOutdatedBrowser2.default.icon,
                icon: ['fas', 'exclamation-circle']
            })), (0, _jsx3.default)('div', {
                className: _BannerOutdatedBrowser2.default['message-body']
            }, void 0, (0, _jsx3.default)('span', {
                className: _BannerOutdatedBrowser2.default['message-headline']
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'did_you_know_that_your_web_browser',
                values: { formalName: formalName, majorVersion: majorVersion }
            })), (0, _jsx3.default)('div', {}, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'browsers_for_best_experience',
                values: { chrome: chrome, edge: edge, firefox: firefox, safari: safari }
            })))));
        }
    }]);
    return BannerOutdatedBrowser;
}(_react.PureComponent);

exports.default = BannerOutdatedBrowser;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/BannerOutdatedBrowser/BannerOutdatedBrowser.js
// module id = kqxN
// module chunks = 60